import { inject, watch, nextTick, Ref, provide } from 'vue';

export function useNotifyParentOnUpdate(data: Ref<unknown>) {
    const widgetUpdated = inject<() => void>('widget-updated');

    watch(
        () => data.value,
        () => {
            nextTick(() => {
                widgetUpdated?.();
            });
        }
    );
}

export function useChildWidgetUpdated(callback: () => void) {
    provide('widget-updated', callback);
}
